module.exports = __webpack_public_path__ + "media/images/category_icons/movies-288691c9cd76ee6b420a2255a74f59b5.svg";